import { render } from "./JoinTheProgram.vue?vue&type=template&id=59ffbf97&scoped=true"
import script from "./JoinTheProgram.vue?vue&type=script&lang=js"
export * from "./JoinTheProgram.vue?vue&type=script&lang=js"

import "./JoinTheProgram.vue?vue&type=style&index=0&id=59ffbf97&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ffbf97"]])

export default __exports__